import * as client from '@dashhudson/api-client/threads/client';

import { createDashHttpClient, type HttpRequestConfig } from '@/apis/dash.http';
import { env } from '@/env';

// POST .../csv is not modeled in the threads OpenAPI spec yet, so it stays on
// the axios client until the backend models it (then it can move to `client`).
const http = createDashHttpClient(env.threadsApiUrl);

export const getThreadsProfile = ({ brandId }: { brandId: number }, config: RequestInit = {}) =>
  client.getBrandsBrandIdProfile(brandId, config);

export const getThreadsProfileAllBrands = (
  { brandIds }: { brandIds: number[] },
  config: RequestInit = {},
) => client.putBrandsProfiles({ brandIds }, config);

export async function postThreadsDemographicsInsightsCSV(
  {
    brandId,
    date,
    socketId,
    breakdown,
  }: { brandId: number; date: string; socketId: string; breakdown: string },
  config: HttpRequestConfig = {},
) {
  return http.post(
    `/brands/${brandId}/profile/follower_demographic_insights/csv`,
    { date, socketId, breakdown },
    config,
  );
}
